import { render, staticRenderFns } from "./uniOffers.vue?vue&type=template&id=da9ffd12&"
import script from "./uniOffers.vue?vue&type=script&lang=js&"
export * from "./uniOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da9ffd12')) {
      api.createRecord('da9ffd12', component.options)
    } else {
      api.reload('da9ffd12', component.options)
    }
    module.hot.accept("./uniOffers.vue?vue&type=template&id=da9ffd12&", function () {
      api.rerender('da9ffd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUqyg5wWuhI0/JS/uniOffers.vue"
export default component.exports